import { render, staticRenderFns } from "./person-upload-file.vue?vue&type=template&id=1605e7a8&scoped=true"
import script from "./person-upload-file.vue?vue&type=script&lang=ts"
export * from "./person-upload-file.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605e7a8",
  null
  
)

export default component.exports